module.exports = function() {
    var Numbers = {};

    Numbers.formatNumberValue = function (value, ratio, id, index) {
        
        if(!value) return 0;
        
        if (typeof value === 'string') {
            value = value.replace(/[^0-9]/g, '');
        }

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return Numbers;
};